export const codeVS_Triangles = `
attribute vec2 a_position;
attribute vec4 a_color;
varying vec4 v_color;

uniform vec2 u_zoom_factor;
uniform vec2 u_pan_offset;

void main() {
  gl_Position = vec4(((a_position - u_pan_offset) * u_zoom_factor).xy, 0, 1);
  v_color = a_color;
}
`;

export const codeFS_Triangles = `
precision mediump float;
varying vec4 v_color;

void main() {
  gl_FragColor = v_color;
  //gl_FragColor = vec4(1, 0, 0.5, 1);
}
`;

export const codeVS_Points = `
attribute vec2 a_position;
attribute vec4 a_color;
varying vec4 v_color;

uniform vec2 u_zoom_factor;
uniform vec2 u_pan_offset;
uniform float u_pointsize;

void main() {
  gl_Position = vec4(((a_position - u_pan_offset) * u_zoom_factor).xy, 0, 1);
  v_color = a_color;
  gl_PointSize = u_pointsize;
}
`;

export const codeFS_Points = `
precision mediump float;
varying  vec4 v_color;
 
void
main()
{
    float r = 0.0, delta = 0.0, alpha = 1.0;
    vec2 cxy = 2.0 * gl_PointCoord - 1.0;
    r = dot(cxy, cxy);
    if (r > 1.0) {
        discard;
    }
    gl_FragColor = v_color * (alpha);
}`;

export const codeFS_PointsAntiAliased = `

precision mediump float;
varying  vec4 v_color;
 
void main()
{
    float r = 0.0, delta = 0.0, alpha = 1.0;
    vec2 cxy = 2.0 * gl_PointCoord - 1.0;
    r = dot(cxy, cxy);
    alpha = 1.0 - smoothstep(0.8, 1.0, r);
    gl_FragColor = v_color * alpha;
}`;

export const codeVS_Lines = `
attribute vec2 a_position;
attribute vec2 a_normal;
attribute vec4 a_color;
varying vec4 v_color;

uniform float u_weight;
uniform vec2 u_zoom_factor;
uniform vec2 u_pan_offset;

void main() {
  gl_Position = vec4(((a_position - u_pan_offset) * u_zoom_factor  + u_weight * a_normal ).xy, 0, 1);
  v_color = a_color;
  gl_PointSize =10.0;
}
`;

export const codeFS_Lines = `
precision mediump float;
varying vec4 v_color;

void main() {
  gl_FragColor = v_color;
  //gl_FragColor = vec4(1, 0, 0.5, 1);
}
`;

export const codeVS_SimpleLines = `
attribute vec2 a_position;

uniform vec2 u_zoom_factor;
uniform vec2 u_pan_offset;
uniform vec4 u_fixed_color;

varying vec4 v_color;

void main() {
  gl_Position = vec4(((a_position - u_pan_offset) * u_zoom_factor).xy, 0, 1);
  v_color = u_fixed_color;
}
`;

export const codeFS_SimpleLines = `
precision mediump float;
varying vec4 v_color;

void main() {
  gl_FragColor = v_color;
  //gl_FragColor = vec4(1,0,0,1);
}
`;

export const codeVS_Bitmap = `
attribute vec2 a_position;
attribute vec2 a_texCoord;

uniform vec2 u_zoom_factor;
uniform vec2 u_pan_offset;

varying vec2 v_texCoord;

void main() {
  gl_Position = vec4(((a_position - u_pan_offset) * u_zoom_factor).xy, 0, 1);

   // pass the texCoord to the fragment shader
   // The GPU will interpolate this value between points
   v_texCoord = a_texCoord;

}
`;

export const codeFS_Bitmap = `
precision mediump float;

uniform float u_fixed_opacity;

// our texture
uniform sampler2D u_image;
 
// the texCoords passed in from the vertex shader.
varying vec2 v_texCoord;


void main() {
   // Look up a color from the texture.
   gl_FragColor = vec4(texture2D(u_image, v_texCoord).xyz, u_fixed_opacity);

}
`;
